export default __webpack_public_path__ + "static/Luna-1d171d3235582ca7c0ca4aa85fa72556.ttf";